import { memo } from 'react';
import { BulkPaymentCompleteTemplate } from 'components/templates/BulkPaymentCompleteTemplate';

type Props = {};

export const BulkPaymentComplete = memo((_props: Props) => {
	return <BulkPaymentCompleteTemplate />;
});
